import { render, staticRenderFns } from "./BasicsFullFilling.vue?vue&type=template&id=7c0c36b9&scoped=true"
import script from "./BasicsFullFilling.vue?vue&type=script&lang=js"
export * from "./BasicsFullFilling.vue?vue&type=script&lang=js"
import style0 from "./BasicsFullFilling.vue?vue&type=style&index=0&id=7c0c36b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0c36b9",
  null
  
)

export default component.exports